<template>
  <stu-main @back="goBack">
    <template slot="nav">
      <div class="teaDetailNav">
        <p>{{videoInfo.video_title}}</p>
      </div>
    </template>
    <template slot="main">
      <div class="main-content">
        <yioks-loading v-show="isLoading"></yioks-loading>
        <template v-if="!isLoading">
          <vue-scroll :ops="ops">
            <div class="prism-player" id="J_prismPlayer"></div>
            <div style="padding:10px 18px 10px 10px;font-size: 16px;">
              <p>视频说明：{{videoInfo.intro || '--'}}</p>
            </div>
          </vue-scroll>
        </template>
      </div>
      <yioks-tips :showTips.sync="IsShowMsg"
        :tips="'您当前视频还没有全部学习完，退出后下次需要重新学习，确定离开此页面吗?'"
        :dw="'420px'"
        @hideTips="hideWarnDialog"></yioks-tips>
    </template>
  </stu-main>
</template>
<script>
  import { studyVideoInfo,educationVideoComplete } from "@/api/education/education";
  import {storageData} from "@/assets/js/storage";
  import ops from "@/assets/js/vuescrollOption";
  export default {
    name: "educationLearnToStu",
    data(){
      return {
        ops: ops(),
        videoInfo:{},
        study_status:"",
        video_learn_status:0,
        AliyunEncryptType:0,
        isLoading:false,
        video_uuid:this.$route.query.video_uuid,
        edu_id:this.$route.query.edu_id,
        IsShowMsg:false,
        play_time:{
          upTime:-1,
          number:0,
          numberErr:0,
        },
        player:null,
        isFinish:false, // 这个视频是否看完了
      }
    },
    created() {
      this.getVideoInfo();
    },
    mounted: function () {
      document.addEventListener('keydown', this.disableDevTools);
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.disableDevTools);
    },
    components: {
      "stu-main": () => import("@/components/LayOut/Common/up-down"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
      "yioks-tips": () => import("@/components/Tips/Dialog"),
    },
    methods: {
      disableDevTools(event) {
        // 禁止 F12
        if (event.key === "F12") {
          event.preventDefault();
        }
        // 禁止 Ctrl + Shift + I 打开开发者工具
        if (event.ctrlKey && event.shiftKey && event.key === 'I') {
          event.preventDefault();
        }
        // 禁止 Ctrl + Shift + C 打开检查元素
        if (event.ctrlKey && event.shiftKey && event.key === 'C') {
          event.preventDefault();
        }
      },
      goBack() {
        // 没学完 返回时候提示一下
        if(this.study_status === 'Incomplete' && this.video_learn_status === 0){
          this.IsShowMsg = true;
        }else{
          this.$router.go(-1);
        }
      },
      hideWarnDialog(bool, flag) {
        this.IsShowMsg = bool;
        if (flag) {
          this.$router.go(-1);
        }
      },
      getVideoInfo() {
        this.isLoading = true;
        studyVideoInfo({ edu_id: this.edu_id,video_uuid:this.video_uuid })
        .then((res) => {
          // console.log(res);
          if (Number(res.data.status) == 0) {
            const {
              video,
              study_status,
              video_learn_status,
              AliyunEncryptType
            } = res.data.result;
            this.videoInfo = video;
            this.study_status = study_status;
            this.video_learn_status = video_learn_status;
            this.AliyunEncryptType = AliyunEncryptType;
            this.isFinish = video_learn_status === 1;
            this.player_init();
            this.isLoading = false;
          }else{
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.error(err);
        });
      },
      player_init(){
        var _this = this;
        this.$nextTick(()=>{
          this.player = new Aliplayer({
            id: 'J_prismPlayer',
//            source: this.videoInfo.video_address,//播放地址，可以是第三方点播地址，或阿里云点播服务中的播放地址。
            source:this.videoInfo.video_Vid + '?auth_key=' + this.videoInfo.video_PlayAuth,//播放地址，可以是第三方点播地址，或阿里云点播服务中的播放地址。
            qualitySort: "asc",
//            format: "mp4",
            mediaType: "video",
            width: "98%",
            height: "477px",
            autoplay: true,
            isLive: false,
            rePlay: false,
            playsinline: true,
            isVBR: false,
            preload: true,
            controlBarVisibility: "hover",
            useH5Prism: true,
            encryptType: this.AliyunEncryptType, // 这玩意 一配置  按F12 就卡死了 注意
            skinLayout: [
              {
                name: "bigPlayButton",
                align: "blabs",
                x: 30,
                y: 80
              },
              {
                name: "H5Loading",
                align: "cc"
              },
              {
                name: "errorDisplay",
                align: "tlabs",
                x: 0,
                y: 0
              },
              {
                name: "infoDisplay"
              },
              {
                name: "tooltip",
                align: "blabs",
                x: 0,
                y: 56
              },
              {
                name: "thumbnail"
              },
              {
                name: "controlBar",
                align: "blabs",
                x: 0,
                y: 0,
                children: this.isFinish ? [
                  {name: "progress", align: "blabs", x: 0, y: 44}, // 可以拖动进度条的 这个视频学完的
                  {
                    name: "playButton",
                    align: "tl",
                    x: 15,
                    y: 12
                  },
                  {
                    name: "timeDisplay",
                    align: "tl",
                    x: 10,
                    y: 7
                  },
                  {
                    name: "fullScreenButton",
                    align: "tr",
                    x: 10,
                    y: 12
                  },
                  {
                    name: "volume",
                    align: "tr",
                    x: 5,
                    y: 10
                  }
                ] : [
                  {
                    name: "playButton",
                    align: "tl",
                    x: 15,
                    y: 12
                  },
                  {
                    name: "timeDisplay",
                    align: "tl",
                    x: 10,
                    y: 7
                  },
                  {
                    name: "fullScreenButton",
                    align: "tr",
                    x: 10,
                    y: 12
                  },
                  {
                    name: "volume",
                    align: "tr",
                    x: 5,
                    y: 10
                  }
                ]
              }
            ]
          },function(player){
            console.log('The player is created.')
            
            // 视频看完的回调
            player.on('ended',function(){
              _this.endPlayer();
            })
            
            // 视频播放中 打印视频播放时间
            player.on('timeupdate',()=>{
              var _time = player.getCurrentTime().toString().split(".")[0];
              _this.player_time_change(_time);
            });
            
            // 播放视频
            player.on('play',function(){
              _this.startPlayer();
            })
          });
        })
      },
      
      player_time_change(time){
        if(this.study_status === 'Incomplete' && this.video_learn_status === 0){ // 进行中的 没学习的 只能同时看一个
          if(this.play_time.upTime == time) return;
          this.play_time.upTime = time;
          if(time % 5 == 0){
            var _num = storageData.getVideoPlayTime();
            if( this.play_time.number != _num){
              this.play_time.numberErr++;
              if(this.play_time.numberErr >= 3){
                this.player.pause();
                this.$notify.error({
                  title: '错误',
                  duration:0,
                  offset:100,
                  message: "同时只能观看一个视频"
                });
              }
            }else{
              this.play_time.numberErr = 0;
            }
            this.play_time.number = this.play_time.number+1;
            storageData.setVideoPlayTime(this.play_time.number);
//            console.log(this.play_time.number)
          }
        }
      },
      
      endPlayer(){
        if(this.study_status === 'Incomplete' && this.video_learn_status === 0){
          educationVideoComplete({edu_id:this.edu_id, video_uuid:this.video_uuid,type:'end'})
          .then((res) => {
            // console.log(res);
            if(Number(res.data.status) == 0){
              this.$notify({
                title:'视频观看成功',
                message:'恭喜你，《' + this.videoInfo.video_title + '》视频已看完',
                type:'success',
                duration:0,
                offset:100
              });
              this.video_learn_status=1; // 这个视频学习完了  是要告诉上面 返回时候不用弹框提示了
            }else{
              this.$notify.error({
                title: '错误',
                duration:0,
                offset:100,
                message: res.data.msg
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
        }
      },
      startPlayer(){
        if(this.study_status === 'Incomplete' && this.video_learn_status === 0){
          educationVideoComplete({edu_id:this.edu_id, video_uuid:this.video_uuid,type:'start'})
          .then((res) => {
            // console.log(res);
            if(Number(res.data.status) == 0){
            
            }else{
              this.$notify.error({
                title: '错误',
                duration:0,
                offset:100,
                message: res.data.msg
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  @import '~@/assets/css/mixin'
  .teaDetailNav{
    flex 1 1 auto
    height 100%
    display flex
    justify-content space-between
    align-items center
    padding 0 15px 0 0
    p {
      font-size $font_size_big
    }
    
  }
  .main-content{
    flex 1 1 auto
    height 100%
    width 100%
    padding-top 10px
    padding-bottom 10px
    background-color $block_bg_color_base
  }
</style>
